import React, { useEffect, useState } from 'react';
import API from '../api';
import Navbar from '../components/Navbar';

const Dashboard = () => {
  const [report, setReport] = useState(null);
  const [lowStock, setLowStock] = useState([]);
  const [overstock, setOverstock] = useState([]);
  const [groupedView, setGroupedView] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showAllLowStock, setShowAllLowStock] = useState(false);
  const [showAllOverstock, setShowAllOverstock] = useState(false);

  const todayStr = new Date().toISOString().split('T')[0];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [reportRes, reorderRes] = await Promise.all([
          API.get(`/invoices/profit-report?start_date=${todayStr}&end_date=${todayStr}`),
          API.get('/products/reorder-priority'),
        ]);
        setReport(reportRes.data);
        setLowStock(reorderRes.data.lowStock);
        setOverstock(reorderRes.data.overstock);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const totalReturnedToday = report?.return_summary?.reduce((sum, r) => sum + parseFloat(r.return_amount || 0), 0) || 0;

  return (
    <div>
      <Navbar />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={styles.container} className="container">
        <div style={styles.header}>
          <h2 style={styles.title}>Dashboard — Today</h2>
        </div>

        {loading ? (
          <div style={styles.loaderWrapper}>
            <div style={styles.spinner}></div>
            <p style={styles.loaderText}>Loading dashboard...</p>
          </div>
        ) : (
          <>
            <div style={styles.cards} className="cards">
              <div style={styles.card}>
                <p style={styles.label}>💵 Cash Revenue</p>
                <p style={{ ...styles.value, color: '#16a34a' }}>LKR {parseFloat(report?.summary?.cash_revenue || 0).toFixed(2)}</p>
                <p style={{ fontSize: '11px', color: '#888', margin: '4px 0 0' }}>Money in cashier</p>
              </div>
              <div style={styles.card}>
                <p style={styles.label}>💳 Credit Revenue</p>
                <p style={{ ...styles.value, color: '#f59e0b' }}>LKR {parseFloat(report?.summary?.credit_revenue || 0).toFixed(2)}</p>
                <p style={{ fontSize: '11px', color: '#888', margin: '4px 0 0' }}>Money owed by customers</p>
              </div>
              <div style={styles.card}>
                <p style={styles.label}>Total Invoices</p>
                <p style={styles.value}>{report?.summary?.total_invoices || 0}</p>
              </div>
              <div style={styles.card}>
                <p style={styles.label}>Returned Amount</p>
                <p style={{ ...styles.value, color: '#ef4444' }}>LKR {totalReturnedToday.toFixed(2)}</p>
              </div>
              <div style={styles.card}>
                <p style={styles.label}>💰 Net Cash in Cashier</p>
                <p style={{ ...styles.value, color: '#4f46e5' }}>LKR {parseFloat(report?.summary?.net_cash_in_cashier || 0).toFixed(2)}</p>
              </div>
              <div style={styles.card}>
                <p style={styles.label}>Low Stock Items</p>
                <p style={{ ...styles.value, color: lowStock.length > 0 ? '#ef4444' : '#16a34a' }}>{lowStock.length}</p>
              </div>
            </div>

            {lowStock.length > 0 && (
              <div style={styles.alertBox}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                  <p style={styles.alertTitle}>🔴 Reorder Now — {lowStock.length} product(s)</p>
                  <button onClick={() => setGroupedView(!groupedView)} style={{ padding: '6px 14px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>
                    {groupedView ? 'Show by Urgency' : '📞 Group by Supplier'}
                  </button>
                </div>
                {groupedView ? (
                  <div style={{ marginTop: '0.75rem' }}>
                    {Object.entries(
                      lowStock.reduce((acc, p) => {
                        const key = p.supplier_name || 'No supplier linked';
                        if (!acc[key]) acc[key] = [];
                        acc[key].push(p);
                        return acc;
                      }, {})
                    ).map(([supplierName, items]) => (
                      <div key={supplierName} style={{ marginBottom: '1rem', background: '#fff', borderRadius: '8px', padding: '0.75rem' }}>
                        <p style={{ fontWeight: '700', fontSize: '13px', color: '#4f46e5', marginBottom: '0.5rem' }}>
                          📦 {supplierName} — {items.length} item(s) to reorder
                        </p>
                        {(showAllLowStock ? items : items.slice(0, 5)).map((p) => (
                          <div key={p.id} style={styles.alertItem}>
                            <span>{p.name}</span>
                            <span style={{ color: '#ef4444', fontWeight: 'bold' }}>
                              Stock: {p.stock}{p.days_of_stock_remaining !== null && ` — ~${p.days_of_stock_remaining}d left`}
                            </span>
                          </div>
                        ))}
                        {!showAllLowStock && items.length > 5 && (
                          <p style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>+{items.length - 5} more from {supplierName}</p>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={styles.alertItems}>
                    {(showAllLowStock ? lowStock : lowStock.slice(0, 5)).map((p) => (
                      <div key={p.id} style={styles.alertItem}>
                        <span>
                          {p.name}
                          <span style={{ color: '#888', fontSize: '12px', marginLeft: '8px' }}>from {p.supplier_name}</span>
                        </span>
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>
                          Stock: {p.stock}{p.days_of_stock_remaining !== null && ` — ~${p.days_of_stock_remaining}d left`}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
                {lowStock.length > 5 && (
                  <button onClick={() => setShowAllLowStock(!showAllLowStock)} style={{ marginTop: '0.75rem', padding: '6px 14px', background: '#fff', color: '#991b1b', border: '1px solid #fca5a5', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>
                    {showAllLowStock ? '▲ Show less' : `▼ Show all ${lowStock.length}`}
                  </button>
                )}
              </div>
            )}

            {overstock.length > 0 && (
              <div style={{ ...styles.alertBox, background: '#fffbeb', borderColor: '#fde68a' }}>
                <p style={{ ...styles.alertTitle, color: '#d97706' }}>🟡 Push These To Sell — {overstock.length} slow-moving product(s)</p>
                <div style={styles.alertItems}>
                  {(showAllOverstock ? overstock : overstock.slice(0, 5)).map((p) => (
                    <div key={p.id} style={styles.alertItem}>
                      <span>
                        {p.name}
                        <span style={{ color: '#888', fontSize: '12px', marginLeft: '8px' }}>from {p.supplier_name}</span>
                      </span>
                      <span style={{ color: '#d97706', fontWeight: 'bold' }}>
                        Stock: {p.stock} — {p.sold_last_30_days} sold/30d
                      </span>
                    </div>
                  ))}
                </div>
                {overstock.length > 5 && (
                  <button onClick={() => setShowAllOverstock(!showAllOverstock)} style={{ marginTop: '0.75rem', padding: '6px 14px', background: '#fff', color: '#d97706', border: '1px solid #fde68a', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>
                    {showAllOverstock ? '▲ Show less' : `▼ Show all ${overstock.length}`}
                  </button>
                )}
              </div>
            )}

            <h3 style={styles.subtitle}>Today's Summary</h3>
            <div className="mobile-scroll-wrapper"><p className="mobile-scroll-hint">← Swipe to see more →</p><table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Invoices</th>
                  <th style={styles.th}>Cash</th>
                  <th style={styles.th}>Credit</th>
                  <th style={styles.th}>Returned</th>
                  <th style={styles.th}>Net Cash in Cashier</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={styles.td}>{new Date().toLocaleDateString()}</td>
                  <td style={styles.td}>{report?.summary?.total_invoices || 0}</td>
                  <td style={{ ...styles.td, color: '#16a34a' }}>LKR {parseFloat(report?.summary?.cash_revenue || 0).toFixed(2)}</td>
                  <td style={{ ...styles.td, color: '#f59e0b' }}>LKR {parseFloat(report?.summary?.credit_revenue || 0).toFixed(2)}</td>
                  <td style={{ ...styles.td, color: '#ef4444' }}>LKR {totalReturnedToday.toFixed(2)}</td>
                  <td style={{ ...styles.td, color: '#4f46e5', fontWeight: 'bold' }}>LKR {parseFloat(report?.summary?.net_cash_in_cashier || 0).toFixed(2)}</td>
                </tr>
              </tbody>
            </table></div>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '2rem' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' },
  title: { fontSize: '24px', margin: 0 },
  cards: { display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '2rem' },
  card: { background: '#fff', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', flex: 1, minWidth: '150px' },
  label: { color: '#888', fontSize: '13px', margin: '0 0 0.5rem' },
  value: { fontSize: '24px', fontWeight: 'bold', margin: 0 },
  alertBox: { background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: '12px', padding: '1rem 1.5rem', marginBottom: '1.5rem' },
  alertTitle: { fontWeight: '500', color: '#991b1b', marginBottom: '0.75rem', fontSize: '14px' },
  alertItems: { display: 'flex', flexDirection: 'column', gap: '0.5rem' },
  alertItem: { display: 'flex', justifyContent: 'space-between', background: '#fff', padding: '6px 12px', borderRadius: '6px', fontSize: '13px' },
  subtitle: { fontSize: '18px', marginBottom: '1rem' },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  th: { padding: '12px 16px', background: '#4f46e5', color: '#fff', textAlign: 'left', fontSize: '14px' },
  td: { padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: '14px' },
  loaderWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '4rem' },
  spinner: { width: '40px', height: '40px', border: '4px solid #e0e7ff', borderTop: '4px solid #4f46e5', borderRadius: '50%', animation: 'spin 0.8s linear infinite' },
  loaderText: { marginTop: '1rem', color: '#888', fontSize: '14px' },
};

export default Dashboard;